import { get, post, put, remove } from "./utils";

export const setting = {
  listMessageType: (parameters, token) => {
    return get("/api/message/types/", parameters, token);
  },
  getMessageType: (id, token) => {
    return get(`/api/message/types/${id}/`, {}, token);
  },
  addMessageType: (parameters, token) => {
    return post("/api/message/types/", parameters, token);
  },
  updateMessageType: (id, parameters, token) => {
    return put(`/api/message/types/${id}/`, parameters, token);
  },
  removeMessageType: (id, token) => {
    return remove(`/api/message/types/${id}/`, {}, token);
  },
  listReportType: (parameters, token) => {
    return get("/api/message/reports/", parameters, token);
  },
  getReportType: (id, token) => {
    return get(`/api/message/reports/${id}/`, {}, token);
  },
  addReportType: (parameters, token) => {
    return post("/api/message/reports/", parameters, token);
  },
  updateReportType: (id, parameters, token) => {
    return put(`/api/message/reports/${id}/`, parameters, token);
  },
  removeReportType: (id, token) => {
    return remove(`/api/message/reports/${id}/`, {}, token);
  },
  listPublication: (parameters, token) => {
    return get("/api/message/publications/", parameters, token);
  },
  getPublication: (id, token) => {
    return get(`/api/message/publications/${id}/`, {}, token);
  },
  addPublication: (parameters, token) => {
    return post("/api/message/publications/", parameters, token);
  },
  updatePublication: (id, parameters, token) => {
    return put(`/api/message/publications/${id}/`, parameters, token);
  },
  removePublication: (id, token) => {
    return remove(`/api/message/publications/${id}/`, {}, token);
  },
  listAdditionalPoint: (parameters, token) => {
    return get("/api/message/additions/", parameters, token);
  },
  getAdditionalPoint: (id, token) => {
    return get(`/api/message/additions/${id}/`, {}, token);
  },
  addAdditionalPoint: (parameters, token) => {
    return post("/api/message/additions/", parameters, token);
  },
  updateAdditionalPoint: (id, parameters, token) => {
    return put(`/api/message/additions/${id}/`, parameters, token);
  },
  removeAdditionalPoint: (id, token) => {
    return remove(`/api/message/additions/${id}/`, {}, token);
  },
  listDeductPoint: (parameters, token) => {
    return get("/api/message/deducts/", parameters, token);
  },
  getDeductPoint: (id, token) => {
    return get(`/api/message/deducts/${id}/`, {}, token);
  },
  addDeductPoint: (parameters, token) => {
    return post("/api/message/deducts/", parameters, token);
  },
  updateDeductPoint: (id, parameters, token) => {
    return put(`/api/message/deducts/${id}/`, parameters, token);
  },
  removeDeductPoint: (id, token) => {
    return remove(`/api/message/deducts/${id}/`, {}, token);
  },
  listColleague: (token) => {
    return get("/api/message/messages/my_colleague/", {}, token);
  },
  listWordStock: (parameters, token) => {
    return get("/api/basis/wordstocks/", parameters, token);
  },
  getWordStock: (id, token) => {
    return get(`/api/basis/wordstocks/${id}/`, {}, token);
  },
  addWordStock: (parameters, token) => {
    return post("/api/basis/wordstocks/", parameters, token);
  },
  updateWordStock: (id, parameters, token) => {
    return put(`/api/basis/wordstocks/${id}/`, parameters, token);
  },
  removeWordStock: (id, token) => {
    return remove(`/api/basis/wordstocks/${id}/`, {}, token);
  },
};
